export default "__VITE_ASSET__B_SW9jvw__"